import React from 'react';
import Navbar from '../../components/navbar';
import DatosCapis from '../../components2/datosCapis';

function InformacionCapis () {
    return (
        <DatosCapis />
    )
}

export default InformacionCapis;